import * as $ from 'jquery'
import 'lightgallery';
import 'daterangepicker/daterangepicker.js';
import externalLinks from './modules/externalLinks';
import daterangePicker, {
    dataSetDaterangePicker
} from './modules/daterangePicker';
// import objectFitImages from 'object-fit-images';
import 'select2/dist/js/select2.full.js';
// import hamburger from './modules/hamburger';
import select2 from './modules/select2';
// import entryFilter from './modules/entryFilter';
import textSwitcher from './modules/textSwitcher';
import lightGallery from './modules/lightGallery';
import clickEvents from './modules/clickEvents';
import bookingForm from './modules/bookingForm';
import customSelect from './modules/custom-select';
import skiDineAround from './modules/skiDineAround';
// import navigation from './modules/navigation'; // Locales Switcher!
// import homePopup from './modules/homePopup';
import homePopup2 from './modules/homePopup2';
import generatedForms from './modules/generated-forms';
// import InstagramFeed from '@jsanahuja/instagramfeed';
// import Instafeed from 'instafeed.js';
import Plyr from 'plyr';

$(function () {
    externalLinks();
    // objectFitImages();
    daterangePicker('einreise', 'single', 'DD.MM.YYYY', 'Datum von');
    daterangePicker('ausreise', 'single', 'DD.MM.YYYY', 'Datum bis');
    daterangePicker('datum');
    dataSetDaterangePicker();
    // hamburger();
    select2();
    // entryFilter();
    textSwitcher();
    lightGallery();
    clickEvents();
    bookingForm();
    customSelect();
    skiDineAround();
    // navigation();
    homePopup2();
    generatedForms();
    const player = new Plyr('#player', {
        controls: ['play', 'progress', 'current-time'],
        autoplay: true,
        resetOnEnd: true,
    });
    // var feed = new Instafeed({
    //     limit: 8,
    //     accessToken:"EAAG5hzKyxakBO5UgdVSaFanMExTS7n9g2YDzs0ZCDGvjDODWitlctxJmF3GvEmP8N58JNE5b7h9R7OOe3t7F9XvZC6fVATaDJIwdM61WQbrztZCSlOifQsUMrFrt9Yp5lPkoPI3VsBAgevSkwcX5KN6P5dXWIEVfvZCpUOC3iIkhgO2zlP3XHWODloam48hGVHtXnpvnZAKE4lJKZBKoI3XKH1MFHeR1s2XraiU71BKZC20pirw2pFVknFAK0ZBgk3L1AwZDZD",
    //     template:
    //         '<a href="{{link}}" target="_blank"><img width="600" height="600" class="object-cover w-full h-full" loading="lazy" src="{{ image }}" /></a>',
    //     after: function () {
    //         $("#instafeed").append(
    //             '<a href="https://www.instagram.com/silvaplana.engadin/" target="_blank" class="sm:flex place-self-center sm:space-x-2 items-center justify-center flex-none text-lg"><div>Instagram</div><svg xmlns="http://www.w3.org/2000/svg" width="32" height="15" fill="none"><path stroke="#00599C" d="M25 14l6-6.5L25 1M0 7.5h31"/></svg></a>'
    //         );
    //     },
    // });
    // feed.run();
    // //
});

// Scrol change navigation
let scrollpos = window.scrollY
const header = document.querySelector("header")
const header_height = 1

const add_class_on_scroll = () => header.classList.add("scrolled")
const remove_class_on_scroll = () => header.classList.remove("scrolled")

window.addEventListener('scroll', function () {
    scrollpos = window.scrollY;

    if (scrollpos >= header_height + 100) {
        add_class_on_scroll()
    } else {
        remove_class_on_scroll()
    }
})
